import { generateURLRappiServices } from 'shared/utils/urls';
import httpService from 'services/HttpService';

import { NEW_MENU_PAGE_PATH } from './newMenuPage.const';

import type { BaseRouteParams } from './menuPage.request';
import type { FullNewMenuCatalogRawResp } from './newMenuPage.response';

function readMigrationStatus(params: BaseRouteParams) {
  const { storeId } = params;
  return httpService.get<never>(
    generateURLRappiServices({
      url: NEW_MENU_PAGE_PATH.MIGRATION_STATUS,
      pathParams: { storeId },
    }),
  );
}

function readFullMenuCatalog(params: BaseRouteParams) {
  const { storeId } = params;
  return httpService.get<FullNewMenuCatalogRawResp>(
    generateURLRappiServices({
      url: NEW_MENU_PAGE_PATH.FULL_MENU,
      pathParams: { storeId },
    }),
  );
}

export const newMenuPageRepository = {
  readMigrationStatus,
  readFullMenuCatalog,
};
